import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { GuiaListMem } from "../../../listados/index";


export interface Params {
    idDocumentacion: number;
}

export interface Props extends kea.ModalProps<undefined, void, Params> {
}

const ImprimirButton = kea.defaultProps(kea.Button, { 
    children: "Imprimir guias", 
    iconClass: fa("print"),
    style: "info"
});

/**
* Modal que se muestra cuando se termina una documentación de forma exitosa 
*/
export class DocumentacionExitosa extends React.PureComponent<Props> {
    idDocumentacion = (props: Props) => props.params.idDocumentacion;
    documentacion = createSelectorRx(this.idDocumentacion, (id) => observeResource(resources.Documentacion.Get, id));
    guias = createSelectorRx(this.documentacion, x => x.Guias);

    onCerrar = () => {
        this.props.onClose(undefined);
    }

    onImprimir = async () => {
        const data = await resources.Documentacion.ImprimirGuias(this.props.params.idDocumentacion);
        kea.printPdf(data);
    }

    private irDocumentacion = async () => {
        history.go("/operativa/documentaciones/" + this.props.params.idDocumentacion);
    }

    render() {
        const value = this.props.value;
        const guias = this.guias(this.props);
        return (
            <kea.Modal
                onClose={this.onCerrar}
                title="Documentación exitosa"
                buttons={[
                    <ImprimirButton onClick={this.onImprimir} />
                ]}
            >

                <kea.Link iconClass={fa("eye")} onClick={this.irDocumentacion} >
                    Ver documentación
                </kea.Link>

                <GuiaListMem value={guias} />
            </kea.Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/guias/documentacion/componentes/okmodal/index.tsx